import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

class LoadingOverlay extends React.Component {
  render() {
    const { classes, loading } = this.props;
    return loading ? (
      <div>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    ) : (
      false
    );
  }
}

export default withStyles(styles, { withTheme: true })(LoadingOverlay);
